/** Pascal-case brand: Cali + .dev black; Jobs primary. */
export function SiteNameWordmark({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-baseline font-semibold tracking-tight ${className}`.trim()}
    >
      <span className="text-black">Cali</span>
      <span className="text-primary">Jobs</span>
      <span className="text-black">.dev</span>
    </span>
  );
}
